import { createSelector } from "@reduxjs/toolkit";

import { selectUploadedFiles } from "./slices/uploaded-files";

import { RootState } from "./index";

export const selectFilesForEncounter = createSelector(
  [
    selectUploadedFiles,
    (_: RootState, clientId: string) => clientId,
    (_: RootState, _c: string, encounterId: string) => encounterId,
  ],
  (uploadedFiles, clientId, encounterId) =>
    Object.values(uploadedFiles || {}).filter(
      (file) =>
        file.subject?.reference === `Patient/${clientId}` &&
        file.context?.encounter?.some((ref) => ref.reference === `Encounter/${encounterId}`),
    ),
);
